import { Validator } from '@vista-digital/validator';
import { iconAssetValidator } from '../../../../../../validators/icon-asset';
export const defaultJourneyActionButtonAppleWalletAssets = {
    icon: {
        name: 'add-to-apple-wallet-button',
        viewBox: '0 0 110.095 34.016'
    }
};
export const JourneyActionButtonAppleWalletAssetsValidator = Validator.object({
    icon: iconAssetValidator
});
